import { everyConfig } from './every-config';

import { ISPFieldConfig } from '../../model';

/**
 * Check condition for some field in fields config
 *
 * @param fieldConfigs - fields config
 * @param condition - condition callback
 */
export function someConfig(
  fieldConfigs: ISPFieldConfig[],
  condition: (field: ISPFieldConfig) => boolean,
): boolean {
  return !everyConfig(fieldConfigs, field => !condition(field));
}

/**
 * Check condition for parents configs for field
 *
 * @param fieldConfig - field config
 * @param condition - condition callback
 */
export function someParentConfig(
  fieldConfig: ISPFieldConfig,
  condition: (field: ISPFieldConfig) => boolean,
): boolean {
  let parentConfig = fieldConfig.parent;
  while (parentConfig) {
    if (condition(parentConfig)) {
      return true;
    }
    parentConfig = parentConfig.parent;
  }
  return false;
}
